const work_immigration = `Suomi tarvitsee ihmisiä muista maista tänne töihin.
Jotkut ihmiset pitävät tätä hyvänä ideana, ja jotkut eivät.
On tärkeää puhua siitä.
Uskon, että työperäinen maahanmuutto voi auttaa Suomea monella tapaa.
Se voi tuoda maahan uusia ideoita ja taitoja ja auttaa sitä kasvamaan.
Se voi myös täyttää työpaikkoja, joita voi olla vaikea täyttää jo Suomessa olevilla ihmisillä.
Tämä voi vahvistaa yrityksiä ja auttaa taloutta.
Mutta jotkut saattavat olla huolissaan työperäisestä maahanmuutosta.
He saattavat ajatella, että se voisi viedä työpaikkoja jo Suomessa olevilta ihmisiltä.
He saattavat myös olla huolissaan siitä, että muista maista tulevat ihmiset muuttavat suomalaista elämäntapaa.
Uskon, että voimme löytää tasapainon.
Voimme varmistaa, että työperäinen maahanmuutto auttaa Suomea kasvamaan ilman, että se vie työpaikkoja täällä jo olevilta ihmisiltä.
Voimme myös varmistaa, että Suomeen tulevat ihmiset oppivat suomalaisesta elämäntavasta ja kunnioittavat sitä.
Yhdessä toimimalla voimme varmistaa, että työperäinen maahanmuutto on kaikkien hyväksi.
Se voi auttaa Suomea vahvistumaan ja monipuolistumaan säilyttäen samalla identiteettinsä ja kulttuurinsa.`;

export default work_immigration;